import { GLOBAL } from 'saddlebag-browser';

export const getJhaToken = (): string | null => {
  const $window = GLOBAL.getWindow();
  return $window?.__internal?.jhaToken ?? null;
};
